import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Hash, ArrowLeft } from "@phosphor-icons/react";
import { hashtagsApi } from "@/lib/apiClient";
import { PassportLogo } from "@/components/Reveal";
import PostCard from "@/components/PostCard";
import CommentsDrawer from "@/components/CommentsDrawer";
import { useTranslation } from "react-i18next";

export default function HashtagPage() {
    const { t } = useTranslation();
    const { tag } = useParams();
    const [data, setData] = useState(null);
    const [commentPost, setCommentPost] = useState(null);
    useEffect(() => { hashtagsApi.detail(tag).then(setData).catch(() => setData({ tag, count: 0, posts: [] })); }, [tag]);
    return (
        <div className="min-h-screen grain" data-testid="hashtag-page">
            <header className="sticky top-0 z-40 glass border-b" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
                <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
                    <Link to="/app" className="flex items-center gap-3">
                        <PassportLogo size={32} />
                        <div className="hidden sm:block">
                            <div className="font-serif text-lg text-white">{t("conciergeApp.passport")}</div>
                            <div className="overline" style={{ fontSize: "8px" }}>{t("hashtag.overline")}</div>
                        </div>
                    </Link>
                    <Link to="/app" className="btn-ghost text-sm !py-2 !px-4"><ArrowLeft size={14} /> {t("auth.back")}</Link>
                </div>
            </header>
            <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-12">
                <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="mb-8">
                    <div className="overline mb-2">{t("hashtag.headerOverline")}</div>
                    <h1 className="font-serif text-5xl md:text-7xl text-white tracking-tighter flex items-center gap-3">
                        <Hash size={44} color="#D4AF37" />
                        <span>{data?.tag || tag}</span>
                    </h1>
                    <div className="text-white/60 mt-3 text-sm">{t("hashtag.postCount", { count: data?.count || 0 })}</div>
                </motion.div>
                <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [&>*]:mb-6">
                    {(data?.posts || []).map((p) => (
                        <PostCard key={p.id} post={p} onOpenComments={setCommentPost} onUpdate={(updates) => setData((prev) => ({ ...prev, posts: prev.posts.map((post) => post.id === p.id ? { ...post, ...updates } : post) }))} />
                    ))}
                    {data && data.posts.length === 0 && (
                        <div className="text-center py-16 text-white/50 text-sm col-span-full">{t("hashtag.noPosts")}</div>
                    )}
                </div>
            </div>
            <CommentsDrawer post={commentPost} open={!!commentPost} onClose={() => setCommentPost(null)} />
        </div>
    );
}
